import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { menuOpenActions } from '../_actions'
export function useMenuOpen() {
  const dispatch = useDispatch()
  return {
    toggleMenu: useCallback(() => dispatch(menuOpenActions.toggleMenu()), [dispatch]),
  }
}
